(() => {
  const todayInBaku = () => {
    const parts = new Intl.DateTimeFormat('en-CA', { timeZone: 'Asia/Baku', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(new Date());
    const part = (key) => parts.find((item) => item.type === key).value;
    return `${part('year')}-${part('month')}-${part('day')}`;
  };
  const displayDate = (value) => {
    const [year, month, day] = value.split('-');
    return `${day}.${month}.${year}`;
  };
  function enhanceDates(form) {
    const dateFields = ['departure', 'return'].map(name => form.elements[name]);
    const calendar = document.createElement('dialog');
    calendar.className = 'fx-calendar';
    calendar.setAttribute('aria-labelledby', 'fx-calendar-title');
    calendar.innerHTML = '<div class="fx-calendar-heading"><h2 id="fx-calendar-title">Tarixi seçin</h2><button type="button" class="fx-calendar-close" aria-label="Təqvimi bağla">×</button></div><div class="fx-calendar-navigation"><button type="button" data-calendar-prev aria-label="Əvvəlki ay">‹</button><p data-calendar-month aria-live="polite"></p><button type="button" data-calendar-next aria-label="Növbəti ay">›</button></div><div class="fx-calendar-week" aria-hidden="true"><span>B.e.</span><span>Ç.a.</span><span>Ç.</span><span>C.a.</span><span>C.</span><span>Ş.</span><span>B.</span></div><div class="fx-calendar-days" role="group" aria-label="Ayın günləri"></div><p class="fx-calendar-note">Səyahətiniz üçün uyğun günü seçin.</p>';
    form.append(calendar);
    let active, month;
    const controls = new Map();
    const iso = date => date.toISOString().slice(0, 10);
    const monthNames = ['Yanvar','Fevral','Mart','Aprel','May','İyun','İyul','Avqust','Sentyabr','Oktyabr','Noyabr','Dekabr'];
    const pretty = value => { const [year, month, day] = value.split('-'); return `${Number(day)} ${monthNames[Number(month)-1]} ${year}`; };
    const sync = field => {
      const button = controls.get(field);
      button.querySelector('span').textContent = field.value ? pretty(field.value) : 'Tarixi seçin';
      button.classList.toggle('is-selected', Boolean(field.value));
      button.disabled = field.disabled;
    };
    const render = () => {
      calendar.querySelector('[data-calendar-month]').textContent = `${monthNames[month.getUTCMonth()]} ${month.getUTCFullYear()}`;
      const min = active.min || todayInBaku();
      const previous = new Date(Date.UTC(month.getUTCFullYear(),month.getUTCMonth(),0));
      calendar.querySelector('[data-calendar-prev]').disabled = iso(previous) < min;
      const grid = calendar.querySelector('.fx-calendar-days');
      grid.replaceChildren();
      const offset = (month.getUTCDay()+6)%7;
      for(let i=0;i<offset;i++){const blank=document.createElement('span');blank.setAttribute('aria-hidden','true');grid.append(blank);}
      const count = new Date(Date.UTC(month.getUTCFullYear(),month.getUTCMonth()+1,0)).getUTCDate();
      for(let day=1;day<=count;day++){
        const value=iso(new Date(Date.UTC(month.getUTCFullYear(),month.getUTCMonth(),day)));
        const button=document.createElement('button');button.type='button';button.textContent=String(day);button.dataset.date=value;
        button.disabled=value<min;button.setAttribute('aria-label',pretty(value));button.setAttribute('aria-pressed',String(value===active.value));
        if(value===todayInBaku())button.classList.add('is-today');
        button.addEventListener('click',()=>{active.value=value;active.dispatchEvent(new Event('input',{bubbles:true}));active.dispatchEvent(new Event('change',{bubbles:true}));sync(active);calendar.close();});
        grid.append(button);
      }
    };
    const open = field => {
      if(field.disabled)return;
      active=field;
      const start=field.value && field.value >= field.min ? field.value : field.min || todayInBaku();
      const date=new Date(start+'T12:00:00Z');month=new Date(Date.UTC(date.getUTCFullYear(),date.getUTCMonth(),1));
      calendar.querySelector('h2').textContent=field.name==='departure'?'Gediş tarixini seçin':'Dönüş tarixini seçin';
      render();calendar.showModal();
      const selected=calendar.querySelector('[aria-pressed="true"]:not(:disabled)') || calendar.querySelector('.fx-calendar-days button:not(:disabled)');
      selected?.focus();
    };
    dateFields.forEach(field=>{
      const button=document.createElement('button');button.type='button';button.className='fx-date-control';button.dataset.dateFor=field.id;
      button.setAttribute('aria-haspopup','dialog');button.setAttribute('aria-labelledby',field.id+'-label '+field.id+'-display');
      form.querySelector('label[for="'+field.id+'"]').id=field.id+'-label';
      button.innerHTML='<span id="'+field.id+'-display">Tarixi seçin</span><svg width="20" height="20" viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="5" width="18" height="16" rx="4"/><path d="M7 3v4m10-4v4M3 11h18m-11 5h.01m4 0h.01"/></svg>';
      field.classList.add('fx-date-native');field.tabIndex=-1;field.setAttribute('aria-hidden','true');field.after(button);controls.set(field,button);
      button.addEventListener('click',()=>open(field));
      field.addEventListener('invalid',event=>{event.preventDefault();if(!calendar.open)open(field);});
      field.addEventListener('change',()=>sync(field));field.addEventListener('input',()=>sync(field));
      field.addEventListener('focus',()=>button.focus());
      sync(field);
    });
    form.addEventListener('change',()=>dateFields.forEach(sync));
    calendar.querySelector('.fx-calendar-close').addEventListener('click',()=>calendar.close());
    calendar.addEventListener('close',()=>{if(active)controls.get(active).focus();});
    calendar.addEventListener('click',event=>{if(event.target!==calendar)return;const r=calendar.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)calendar.close();});
    for(const [selector,delta] of [['[data-calendar-prev]',-1],['[data-calendar-next]',1]])calendar.querySelector(selector).addEventListener('click',()=>{month=new Date(Date.UTC(month.getUTCFullYear(),month.getUTCMonth()+delta,1));render();});
    calendar.querySelector('.fx-calendar-days').addEventListener('keydown',event=>{
      const directions={ArrowLeft:-1,ArrowRight:1,ArrowUp:-7,ArrowDown:7};
      if(!(event.key in directions)||!event.target.dataset.date)return;
      event.preventDefault();const d=new Date(event.target.dataset.date+'T12:00:00Z');d.setUTCDate(d.getUTCDate()+directions[event.key]);if(iso(d)<active.min)return;
      if(d.getUTCMonth()!==month.getUTCMonth()||d.getUTCFullYear()!==month.getUTCFullYear()){month=new Date(Date.UTC(d.getUTCFullYear(),d.getUTCMonth(),1));render();}
      calendar.querySelector('[data-date="'+iso(d)+'"]')?.focus();
    });
  }

  const normalizedPlace = (value) => {
    const match = value.match(/\(([A-Z]{3})\)/i);
    if (match) return match[1].toUpperCase();
    const normalized = value.trim().toLocaleUpperCase('az').replace(/\s+/g, ' ');
    const known = Array.from(document.querySelectorAll('#fx-airports option')).find((item) => item.value.split(' (')[0].toLocaleUpperCase('az') === normalized);
    return known ? known.value.match(/\(([A-Z]{3})\)/)[1] : normalized;
  };
  function init(root) {
    if (!root || root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const form = root.querySelector('[data-fx-form]');
    const fields = form.elements;
    const error = root.querySelector('[data-fx-error]');
    const dialog = root.querySelector('[data-fx-preview]');
    const messageNode = root.querySelector('[data-fx-message]');
    const whatsapp = root.querySelector('[data-fx-whatsapp]');
    const returnField = root.querySelector('[data-fx-return]');
    const phone = root.dataset.phone.replace(/\D/g, '');
    fields.departure.min = todayInBaku();
    fields.return.min = todayInBaku();
    const label = (name) => form.querySelector(`label[for="${fields[name].id}"]`).childNodes[0].textContent.trim();
    const option = (name) => fields[name].selectedOptions[0].textContent.trim();
    const tripLabel = () => form.querySelector('input[name="trip"]:checked + span').textContent.trim();
    const showError = (message, field) => {
      error.textContent = message;
      error.hidden = false;
      if (field) { field.setCustomValidity(message); field.reportValidity(); field.focus(); }
    };
    const updateReturn = () => {
      const oneWay = fields.trip.value === 'oneway';
      returnField.hidden = oneWay;
      fields.return.disabled = oneWay;
      fields.return.required = !oneWay;
      fields.return.min = fields.departure.value || todayInBaku();
      fields.return.setCustomValidity('');
      error.hidden = true;
    };
    form.addEventListener('change', (event) => {
      if (event.target.name === 'trip' || event.target.name === 'departure') updateReturn();
    });
    form.addEventListener('input', (event) => {
      if (typeof event.target.setCustomValidity === 'function') event.target.setCustomValidity('');
      if (['origin', 'destination'].includes(event.target.name)) fields.destination.setCustomValidity('');
      if (['adults', 'infants'].includes(event.target.name)) fields.infants.setCustomValidity('');
      error.hidden = true;
    });
    root.querySelector('[data-fx-swap]').addEventListener('click', () => {
      const originMeta = {...fields.origin.dataset};
      const destinationMeta = {...fields.destination.dataset};
      [fields.origin.value, fields.destination.value] = [fields.destination.value, fields.origin.value];
      for (const key of ['airportValue','airportCountry']) {
        if (destinationMeta[key]) fields.origin.dataset[key] = destinationMeta[key]; else delete fields.origin.dataset[key];
        if (originMeta[key]) fields.destination.dataset[key] = originMeta[key]; else delete fields.destination.dataset[key];
      }
      fields.destination.setCustomValidity('');
      error.hidden = true;
      fields.destination.focus();
    });
    root.querySelectorAll('[data-fx-destination]').forEach((button) => {
      button.addEventListener('click', () => {
        fields.destination.value = button.dataset.fxDestination;
        fields.destination.setCustomValidity('');
        error.hidden = true;
        form.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'center' });
        fields.departure.focus({ preventScroll: true });
      });
    });
    root.querySelectorAll('[data-fx-close]').forEach((button) => button.addEventListener('click', () => dialog.close()));
    dialog.addEventListener('click', (event) => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    });
    form.addEventListener('submit', (event) => {
      event.preventDefault();
      [fields.origin, fields.destination].forEach((field) => { field.value = field.value.trim(); });
      error.hidden = true;
      if (!form.reportValidity()) return;
      if (normalizedPlace(fields.origin.value) === normalizedPlace(fields.destination.value)) return showError(root.dataset.errorSame, fields.destination);
      if (fields.departure.value < todayInBaku()) return showError(root.dataset.errorDate, fields.departure);
      if (fields.trip.value === 'roundtrip' && fields.return.value < fields.departure.value) return showError(root.dataset.errorReturn, fields.return);
      if (Number(fields.infants.value) > Number(fields.adults.value)) return showError(root.dataset.errorInfant, fields.infants);
      if (!/^\d{8,15}$/.test(phone)) return showError(root.dataset.errorPhone);
      const airportNames = {"AUH": "Zayed International Airport", "AYT": "Antalya International Airport", "CDG": "Charles de Gaulle International Airport", "DOH": "Hamad International Airport", "DXB": "Dubai International Airport", "FCO": "Rome–Fiumicino Leonardo da Vinci International Airport", "FRA": "Frankfurt Main Airport", "GYD": "Heydar Aliyev International Airport", "IST": "İstanbul Airport", "LHR": "London Heathrow Airport", "SAW": "Istanbul Sabiha Gökçen International Airport", "TBS": "Tbilisi International Airport"};
      const routeDetails = (field, direction) => {
        const value = field.value.trim();
        const match = value.match(/\(([A-Z]{3})\)\s*$/i) || value.match(/^([A-Z]{3})$/i);
        const code = match ? match[1].toUpperCase() : '';
        const withoutCode = value.replace(/\s*\([A-Z]{3}\)\s*$/i, '').trim();
        const parts = withoutCode.split(' — ');
        const seed = code && Array.from(document.querySelectorAll('#fx-airports option')).find(item => item.value.endsWith(`(${code})`));
        const city = parts.length > 1 ? parts[0] : (withoutCode.toUpperCase() === code ? seed?.value.split(' (')[0].split(' — ')[0] || 'Dəqiqləşdirilməyib' : withoutCode);
        const airport = parts.length > 1 ? parts.slice(1).join(' — ') : airportNames[code] || 'Dəqiqləşdirilməyib';
        const result = [`${direction} şəhəri: ${city}`, `${direction} hava limanı: ${airport}`, `${direction} aeroport kodu (IATA): ${code || 'Seçilməyib'}`];
        if (field.dataset.airportValue === value && field.dataset.airportCountry) result.push(`${direction} ölkəsi: ${field.dataset.airportCountry}`);
        return result;
      };
      const lines = [root.dataset.messageTitle, '', '*MARŞRUT*', ...routeDetails(fields.origin, 'Gediş'), '', ...routeDetails(fields.destination, 'Təyinat'), '', '*SƏFƏR TARİXLƏRİ*', `Səfər növü: ${tripLabel()}`, `${label('departure')}: ${displayDate(fields.departure.value)}`];
      if (fields.trip.value === 'roundtrip') {
        lines.push(`${label('return')}: ${displayDate(fields.return.value)}`);
        lines.push(`Dönüş marşrutu: ${fields.destination.value} → ${fields.origin.value}`);
      } else lines.push('Dönüş: tələb olunmur (bir istiqamət)');
      const passengerCount = ['adults', 'children', 'infants'].reduce((sum, name) => sum + Number(fields[name].value), 0);
      lines.push('', '*SƏRNİŞİNLƏR*', `Ümumi sərnişin sayı: ${passengerCount}`, `${label('adults')}: ${fields.adults.value} (12 yaş və yuxarı)`, `${label('children')}: ${fields.children.value} (2–11 yaş)`, `${label('infants')}: ${fields.infants.value} (2 yaşdan kiçik)`, `${label('cabin')}: ${option('cabin')}`);
      lines.push('', '*BAQAJ VƏ BÜDCƏ*', `${label('baggage')}: ${fields.baggage.value === 'any' ? 'Seçim bildirilməyib — əməkdaşla dəqiqləşdiriləcək' : option('baggage')}`);
      lines.push(`${label('budget')}: ${fields.budget.value ? `${fields.budget.value} ${option('currency')} (bütün sərnişinlər üçün ümumi)` : 'Bildirilməyib'}`);
      lines.push('', '*ÜSTÜNLÜKLƏR*', `Tarixlərdə çeviklik: ${fields.flexible.checked ? 'Bəli — yaxın tarixlərə də baxıla bilər' : 'Bildirilməyib — seçilmiş tarixlər əsas götürülsün'}`);
      lines.push('', `${label('notes')}: ${fields.notes.value.trim() || 'Yoxdur'}`, '', root.dataset.messageEnd);
      const message = lines.join('\n');
      messageNode.textContent = message;
      whatsapp.href = `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else { dialog.setAttribute('open', ''); dialog.scrollIntoView({ block: 'center' }); }
    });
    const passengerSummary = root.querySelector('[data-fx-passenger-summary]');
    const summarizePassengers = () => {
      const total = ['adults', 'children', 'infants'].reduce((sum, name) => sum + Number(fields[name].value || 0), 0);
      passengerSummary.textContent = `${total} sərnişin · ${option('cabin')}`;
    };
    form.addEventListener('input', summarizePassengers);
    form.addEventListener('change', summarizePassengers);
    root.querySelector('.fx-travel-options').addEventListener('invalid', () => { root.querySelector('.fx-travel-options').open = true; }, true);
    updateReturn();
    summarizePassengers();
    enhanceDates(form);
    root.querySelector('[data-fx-submit]').disabled = false;
  }
  document.querySelectorAll('[data-fx-site]').forEach(init);
  document.querySelectorAll('.fx-mobile-menu a').forEach((link) => link.addEventListener('click', () => link.closest('details').removeAttribute('open')));
  document.addEventListener('shopify:section:load', (event) => init(event.target.querySelector('[data-fx-site]')));
})();
